var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"ui-tab-button",class:{ active: _vm.active, disabled: _vm.disabled },attrs:{"type":"button","aria-selected":String(_vm.active),"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }